module.exports = __webpack_public_path__ + "static/media/neutral.a1bf9691.png";